// меняет string_value_1 на stringValue1
export const convertToCamelCase = (s: string): string =>
  s.replace(/_./g, x => x[1].toUpperCase());
